/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {DEFAULT_EMAIL_TEMPLATE} from './email-default-template-body';

export {DEFAULT_EMAIL_TEMPLATE};

const DEFAULT_STYLE_FIELDS = {
  h1: 'font-size: 25px;padding: 10px 0;margin: 0;',
  h2: 'font-size: 20px;padding: 10px 0;margin: 0;',
  pLarge: 'font-size: 17px;padding: 10px 0;margin: 0;',
  pMedium: 'font-size: 14px;padding: 8px 0;margin: 0;',
  pSmall: 'font-size: 10px;padding: 5px 0;margin: 0;',
  pSmaller: 'font-size: 5px;padding: 5px 0;margin: 0;'
};

export function updateEmailTemplateInfo(model: any): void {
  model.specifyEmailTemplate = _.isString(model.template)
    && _.trim(model.template).length > 0
    && model.template !== DEFAULT_EMAIL_TEMPLATE;
}

export function applyDefaultEmailTemplateContent(model: any): void {
  if (!model.specifyEmailTemplate) {
    model.template = DEFAULT_EMAIL_TEMPLATE || '';
  }
}

export function initEmailTemplateModel(model: any): void {
  model.type = model.type || 'SPECIFIC';
  updateEmailTemplateInfo(model);
  applyDefaultEmailTemplateContent(model);
  Object.keys(DEFAULT_STYLE_FIELDS).forEach((key) => {
    if (!model[key]) {
      model[key] = DEFAULT_STYLE_FIELDS[key];
    }
  });
}

export function prepareEmailTemplateForSubmit(model: any): void {
  if (!model.specifyEmailTemplate || model.template === DEFAULT_EMAIL_TEMPLATE) {
    model.template = '';
  }
}

export function getEmailTemplateTeamQueryParams(LocalUserPermissions: any): Record<string, any> {
  const perms = LocalUserPermissions.getAllVisPermissions();
  const teamTypes: string[] = [];
  if (perms.AX_ADVERTISER_ADMIN === true || perms.AX_ADVERTISER_TEAM_ADMIN === true) {
    teamTypes.push('AX_ADVERTISER');
  }
  if (perms.AX_PUBLISHER_ADMIN === true || perms.AX_PUBLISHER_TEAM_ADMIN === true) {
    teamTypes.push('AX_PUBLISHER');
  }
  return {minimal: true, teamTypes: teamTypes.join(';')};
}
